"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeSanitizer = void 0;
var CodeSanitizer = /** @class */ (function () {
    function CodeSanitizer() {
    }
    CodeSanitizer.prototype.format = function (value) {
        if (typeof value !== 'string') {
            return '';
        }
        return value.replace(/\s*/g, '').toUpperCase();
    };
    CodeSanitizer.prototype.sanitize = function (value) {
        return value.replace(/\s*/g, '').toUpperCase();
    };
    CodeSanitizer.prototype.blockUnallowedCharacters = function (value) {
        return value.replace(/[^A-Z0-9]*/gi, '');
    };
    return CodeSanitizer;
}());
exports.CodeSanitizer = CodeSanitizer;
//# sourceMappingURL=CodeSanitizer.js.map